"use client";

import styled from "styled-components";
import Image from "next/image";
import {useEffect, useState} from "react";
import blur from '@/public/images/static/blur.jpg'

export const Img = ({
                        src,
                        srcSm,
                        position,
                        objectFit,
                        height,
                        width,
                        alt,
                        left,
                        margin,
                        right,
                        top,
                        bottom,
                        transition,
                        priority,   // pass true for above-the-fold / LCP images
                    }) => {

    const [deviceWidth, setDeviceWidth] = useState(0);

    // set device width with SSR safety
    useEffect(() => {
        function HandleWidth() {
            if (typeof window !== 'undefined') {
                setDeviceWidth(window.innerWidth);
            }
        }

        // Set initial width
        HandleWidth();
        
        if (typeof window !== 'undefined') {
            window.addEventListener('resize', HandleWidth);
        }
        
        return () => {
            if (typeof window !== 'undefined') {
                window.removeEventListener('resize', HandleWidth);
            }
        };
    }, []); // Add empty dependency array to prevent infinite re-renders

    return (
        <StyledImg className='global-image' objectFit={objectFit} margin={margin} position={position} left={left}
                   right={right} top={top}
                   bottom={bottom} height={height} width={width} transition={transition}>
            <Image 
                   blurDataURL="data:image/jpeg;base64,/9j/4AAQSkZJRgABAQEAYABgAAD//gAfQ2F0YWxvZyBWaWV3ZXIgRXhwb3J0IEZpbGUgU3VjY2VzcyAg/9sAQwAFAwQEBAMFBAQEBQUFBgcMCAcHBwcPCwsJDBEPEhIRDxERExYcFxMUGhURERghGBodHR8fHxMXIiQiHiQcHh8e/9sAQwEFBQUHBgcOCAgOHhQRFB4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4eHh4e/8AAEQgAAQABAwEiAAIRAQMRAf/EAB8AAAEFAQEBAQEBAAAAAAAAAAABAgMEBQYHCAkKC//EALUQAAIBAwMCBAMFBQQEAAABfQECAwAEEQUSITFBBhNRYQcicRQygZGhCCNCscEVUtHwJDNicoIJChYXGBkaJSYnKCkqNDU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6g4SFhoeIiYqSk5SVlpeYmZqio6Slpqeoqaqys7S1tre4ubrCw8TFxsfIycrS09TV1tfY2drh4uPk5ebn6Onq8fLz9PX29/j5+v/EAB8BAAMBAQEBAQEBAQEAAAAAAAABAgMEBQYHCAkKC//EALURAAIBAgQEAwQHBQQEAAECdwABAgMRBAUhMQYSQVEHYXETIjKBkQgUQqGxwdHwFSNCsuMCUdNTc5KFCBY0N3ck8MKHdKIkBh3k+8jm" 
                   placeholder="blur"
                   priority={!!priority}
                   alt={alt || src || 'Image'} 
                   fill
                   style={{ objectFit: 'cover' }}
                   src={src ? (deviceWidth > 600 ? src : (srcSm || src)) : blur}
                   sizes="(max-width: 600px) 100vw, (max-width: 1200px) 50vw, 33vw"
            />
        </StyledImg>
    );
};

const StyledImg = styled.div`
    position: ${props => props.position || 'absolute'};
    height: ${props => props.height || '100%'};
    width: ${props => props.width || '100%'};
    top: ${props => props.top || 0};
    left: ${props => props.left || 0};
    bottom: ${props => props.bottom || 0};
    right: ${props => props.right || 0};
    margin: ${props => props.margin || 0};
    overflow: hidden;

    img {
        ${props => props.transition && `transition: 1.4s ease`} //transition: 1.4s ease;
    }
`;
